import { useEffect, useState } from "react";
import { Box } from "@mui/material";
import gsap from "gsap";
import ProjectsPage from ".";

const LogoRevealLuxuria = () => {
  const [isRevealed, setIsRevealed] = useState(false);

  useEffect(() => {
    const tl = gsap.timeline({
      defaults: { duration: 1.2, ease: "expo.inOut" },
      onComplete: () => setIsRevealed(true),
    });

    tl.to(".slide-1", { width: 0 })
      .to("#introduction", { height: 0, delay: 0.3 });

    return () => {
      tl.kill(); // Cleanup animation
    };
  }, []);

  return (
    <Box sx={{ overflow: "hidden", position: "relative" }}>
      {/* Smooth Intro Animation */}
      {!isRevealed && (
        <Box
          id="introduction"
          sx={{
            width: "100vw",
            height: "100vh",
            position: "fixed",
            zIndex: 105,
            backgroundColor: "#141414",
            top: 0,
            left: 0,
            overflow: "hidden",
          }}
        >
          <Box
            sx={{
              width: "100vw",
              height: { xs: "80vh", md: "100vh" },
              position: "relative",
            }}
          >
            <img
              className="banner-logo"
              src="https://dprstorage.b-cdn.net/kolla/kollathumbna.png"
              alt="Best apartments in Hyderabad by Kolla Group"
              title="Kolla Group Best Apartments in chanda nagar"
              style={{
                position: "absolute",
                left: "50%",
                top: "50%",
                transform: "translate(-50%, -50%)",
                width: "80%",
                maxWidth: "1600px",
              }}
            />
          </Box>

          {/* Sliding Panels */}
          <Box
            className="slide slide-1"
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              right: 0,
              bottom: 0,
              backgroundColor: "#fff",
              zIndex: 999,
            }}
          />
        </Box>
      )}

      {/* Main Content Appears Smoothly */}
      <Box
        sx={{
          position: "relative",
          zIndex: 100,
          width: "100%",
          height: "auto",
          backgroundColor: "transparent",
          overflow: "hidden",
        }}
      >
        <ProjectsPage />
      </Box>
    </Box>
  );
};

export default LogoRevealLuxuria;
